// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import { useEffect, useRef } from "react"
import { detectTransition, notify } from "@/lib/live-signal"

// Fires a Web Notification once per observed running->terminal transition.
// Never fires on first render (prevStatusRef starts undefined), and notify()
// no-ops unless Notification permission was already granted in a prior session.
export const useCompletionNotification = (
  cycleId: string,
  status: CycleStatus | undefined,
): void => {
  const prevStatusRef = useRef<CycleStatus | undefined>(undefined)

  useEffect(() => {
    if (status === undefined) return
    if (detectTransition(prevStatusRef.current, status)) {
      notify("Cycle finished", { body: `Cycle ${cycleId} is now ${status}.` })
    }
    prevStatusRef.current = status
  }, [status, cycleId])
}
